import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import cs from 'classnames'
export {Thead, Th, Tr, Td} from 'reactable'
import {Tr as OriginalTr} from 'reactable'
import {Td} from 'reactable'
import {Table as OrigTable} from 'reactable'
import {Motion, spring} from 'react-motion'
import Collapse from 'react-collapse'
import styles from './reactable.scss'

import i18n from 'lib/i18n'
const _ = i18n()

@connect((state) => ({
	innerWidth: state.responsive.innerWidth,
}))
class CollapseTdContent extends Component {
	static propTypes = {
		innerWidth: PropTypes.number,
	}
	constructor(props) {
		super(props)
		this.state = {width: 100}
	}
	calcWidth() {
		let findTr = this.wrapper
		while (findTr && findTr.tagName !== 'TR') {
			findTr = findTr.parentElement
		}
		if (findTr) {
			const width = findTr.clientWidth
			if (this.state.width !== width) {
				this.setState({width})
			}
		}
	}
	componentDidMount() {this.calcWidth()}
	componentWillReceiveProps(nextProps) {
		if (nextProps.innerWidth !== this.props.innerWidth) {
			this.calcWidth()
		}
	}

	render() {
		const {isOpened = false, children} = this.props
		const {width} = this.state

		return (
			<div
				ref={el => this.wrapper = el}
				className={cs(styles.collapseWrap)}
			>
				<Motion style={{d: spring(isOpened ? 0 : -90)}}>{({d}) =>
					<div className={styles.arrow} style={{transform: `rotate(${d}deg)`}}>
						&nbsp;
					</div>
				}</Motion>
				<Collapse
					keepCollapsedContent
					isOpened={isOpened}
					onClick={ev => ev.stopPropagation()}
					style={{width}}
				>
					{children}
				</Collapse>
			</div>
		)
	}
}
export const collapseTd = ({column, ...rest}) => (
	<Td column={column}>
		<CollapseTdContent {...rest}/>
	</Td>
)

export const collapseTdWithClass = ({column, className, ...rest}) => (
	<Td column={column} className={className}>
		<CollapseTdContent {...rest}/>
	</Td>
)

@connect(
	(state) => ({
		locale: state.app.lang,
	}),
	null, null, {withRef: true}
)
class ConnTable extends Component {
	static propTypes = {
		className: PropTypes.string,
		children: PropTypes.node,
	}
	visibleItems() {
		return this.table.visibleItems()
	}
	render() {
		const {className, ...rest} = this.props

		// TODO: make reactable reset page when children change, this is a terrible hack
		return (
			<div className={cs(styles.tableContainer, className)}>
				<OrigTable
					key={this.props.children.toString().length}
					filterPlaceholder={_('filter')}
					ref={el => {this.table = el}}
					itemsPerPage={10}
					topPagination
					bottomPagination
					filterCleanBtn
					{...rest}
				/>
			</div>
		)
	}
}

export class Table extends Component {
	visibleItems() {
		return this.table.getWrappedInstance().visibleItems()
	}
	render() {
		return (
			<ConnTable ref={el => {this.table = el}} {...this.props}/>
		)
	}
}



// WEBPACK FOOTER //
// ./components/reactable.jsx